// extracted by mini-css-extract-plugin
export default {"CheckboxItem":"CheckboxItem_CheckboxItem__hl0fs","CheckboxItem__label":"CheckboxItem_CheckboxItem__label__mjzXP"};